(function(window) {

  //LIVE VERSION API
    window.__env = window.__env || {};
    window.__env.API_ROOT='https://113.207.49.239:5221/';
    window.__env.Line_1='https://fhusa.fhzqyapi.com:5221/';
    window.__env.Line_2='https://qzrb2.fhzqpc.com:5221/';


  //TEST VERSION API
    // window.__env = window.__env || {};
    // window.__env.API_ROOT='https://api.fhzq.peizi.hkcorp.vip/';
    // window.__env.Line_1='https://api.fhzq.peizi.hkcorp.vip/';
    // window.__env.Line_2='https://api.fhzq.peizi.hkcorp.vip/';

  //vue_pc
  window.__env.buildType = 1;

  //windows_pc
  // window.__env.buildType = 6;




})(this);

/*
  web PC 电脑网页版 (blue) = 1
  web Mobile 手机网页版 (green) = 2
  Mobile APK 安卓版 (yellow) = 3
  Apple Bookmark 苹果书签版 (grey) = 4
  Apple TF 苹果 TF版 (cyan) = 5
*/

// export const buildConfigs = {
//   buildType: 1
// };



//////////////////
// WEBPACK FOOTER
// ./static/config.js
// module id = /98u
// module chunks = 1